import { oneLine } from 'common-tags/es';

const data = {
    type: 'contentpage',
    path: '/measures/essentials',
    meta: {
        title: 'Access to essentials | Child Poverty',
    },
    title: 'Access to essentials',
    intro: oneLine`Over <b>150,000</b>, or <b>13.4%</b> of tamariki currently live in households experiencing material 
        hardship. By 2028, the Government has committed to reduce this to <b>6%</b>.`,
    image: {
        filename: 'Essentials.png',
        alt: '',
    },
    content: [
        oneLine`<p>Experiencing material hardship means being unable to afford six or more items that most people 
            regard as essentials, such as having enough to eat, warm clothes and sturdy shoes.</p>`,
        oneLine`<p><b>66,100</b>, or <b>6%</b> of tamariki live in households experiencing severe material hardship, which 
            means going without nine or more essentials for a decent standard of living.</p>`,
        oneLine`<p>Work and Income experienced an increase in the number of hardship grants increased from 1.5 million 
            in the year to March 2019, to 2.2 million in the year to March 2020. It is likely the ongoing impacts of 
            COVID-19 will increase this demand even further.</p>`,
    ],
};

export default data;
